import { TYPES, UPPERS, getCategory } from './catalog';

export const ISLAND_SPECS = {
  cuisine: { zone: 'base', h: 900, parts: [{ k: 'drawer', h: 160 }, { k: 'door' }] },
  dressing: { zone: 'base', h: 950, parts: [{ k: 'drawer' }, { k: 'drawer' }, { k: 'drawer' }] },
  bar: { zone: 'base', h: 1050, parts: [{ k: 'door' }] },
  exterieur: { zone: 'free', free: 'table', h: 1050 },
};

export const WALL_KEYS = { A: 'modules', B: 'modulesB', C: 'modulesC' };
export const WALL_LABELS = { A: 'Mur A · fond', B: 'Mur B · gauche', C: 'Mur C · droite' };
export const wallsFor = (layout) => (layout === 'U' ? ['A', 'B', 'C'] : layout === 'L' ? ['A', 'B'] : ['A']);

export const upperFor = (spec, m, cat, side) => {
  if (!m.upper || m.upper === 'none' || !cat.uppers.includes(m.upper) || spec.zone === 'tall') return null;
  if (side && m.upper === 'hood') return null;
  const up = UPPERS[m.upper];
  if (!up || (spec.elev || 0) + spec.h > up.elev - 100) return null;
  return up;
};

const mk = (m, idx, cat, wall) => {
  const spec = TYPES[m.type];
  return { ...m, idx, wall, spec, w: m.w, h: spec.h, d: spec.d, elev: spec.elev || 0, up: upperFor(spec, m, cat, wall !== 'A') };
};

export function computeLayout(cfg) {
  const cat = getCategory(cfg.category);
  const layout = cfg.layout || 'I';
  const walls = wallsFor(layout);
  const modsA = (cfg.modules || []).filter((m) => TYPES[m.type]);
  const side = (k) => (walls.includes(k) ? (cfg[WALL_KEYS[k]] || []).filter((m) => TYPES[m.type] && TYPES[m.type].zone !== 'free') : []);
  const run = modsA.reduce((s, m) => s + m.w, 0);
  const W = Math.max(cfg.room.w, run);
  const H = cfg.room.h;
  let x = (W - run) / 2;
  const items = modsA.map((m, i) => { const it = mk(m, i, cat, 'A'); it.x = x; it.ex = x; x += m.w; return it; });
  const maxD = Math.max(600, ...items.map((i) => i.d));
  let n = items.length;
  const sideItems = (k) => {
    let u = maxD;
    return side(k).map((m) => { const it = mk(m, n++, cat, k); it.u0 = u; u += m.w; return it; });
  };
  const itemsB = sideItems('B');
  const itemsC = sideItems('C');
  const runB = itemsB.reduce((s, i) => s + i.w, 0), runC = itemsC.reduce((s, i) => s + i.w, 0);
  const sideD = Math.max(0, ...itemsB.map((i) => i.d), ...itemsC.map((i) => i.d));
  let island = null;
  if (cat.island.allowed && cfg.island.on) {
    const spec = ISLAND_SPECS[cat.id];
    const z0 = maxD + (cat.id === 'dressing' ? 900 : 1100);
    const free = W - 2 * (sideD ? sideD + 900 : 200);
    island = { spec, w: Math.max(600, Math.min(cfg.island.w, free)), d: cfg.island.d, h: spec.h, z0, idx: 99, uid: 'island', elev: 0 };
    island.x = (W - island.w) / 2;
  }
  const D = Math.max(cfg.room.d, island ? island.z0 + island.d + 900 : maxD + 900, maxD + runB + 300, maxD + runC + 300);
  itemsB.forEach((it) => { it.ex = D - it.u0 - it.w; });
  itemsC.forEach((it) => { it.ex = it.u0; });
  return {
    cat, W, H, D, items, island, run, maxD, layout, walls, itemsB, itemsC, sideD, facade: cfg.facade || 'lisse',
    all: [...items, ...itemsB, ...itemsC],
    wall: { A: { W, items }, B: { W: D, items: itemsB }, C: { W: D, items: itemsC } },
  };
}

export const boxFor = (it) => {
  const { spec, h, elev } = it;
  if (spec.zone !== 'free') return { y0: elev, y1: elev + h };
  if (spec.free === 'bath' || spec.free === 'bench') return { y0: 0, y1: h };
  if (spec.free === 'planter') return { y0: 0, y1: h * 0.55 };
  if (spec.free === 'desk' || spec.free === 'table') return { y0: h - 45, y1: h };
  return null;
};
